import {
  useTheme,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  Link as MuiLink,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { withPather } from "react-pather";

const Revealable = ({ pather, advanced, setAdvancedSafe }) => {
  const theme = useTheme();

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Box>
        <FormControlLabel
          checked={advanced.revealable}
          control={<Checkbox />}
          label={<b>Reveal source link</b>}
          labelPlacement="end"
          onChange={(e) => setAdvancedSafe({ revealable: e.target.checked })}
        />
      </Box>
      <Box>
        <Typography component="div" sx={{ fontSize: "12px" }}>
          Determines if the source link is visible after expiration or on the{" "}
          <MuiLink
            component={RouterLink}
            to={pather.front.checkSubmit}
            underline="hover"
            sx={{
              color: theme.palette.text.main,
            }}
          >
            <b>Check Link</b>
          </MuiLink>{" "}
          page.
        </Typography>
      </Box>
    </Box>
  );
};

export default withPather()(Revealable);
